export default __webpack_public_path__ + "static/Slyme-2cc4210398b1871b364a5cc6344008c1.jpg";